import { clevertapEvent } from 'utils/clevertap';
import { capitalizeFirstLetter } from 'utils/general';
import { CompanyInfo } from '../../../@types/company';

export const clevertapCompanyViewed = (company: CompanyInfo) => {
  const sectoralIndex = company.indexes_data.find(
    (s) => s.company_type === 'indeks-sektoral',
  );

  const companyStatus = capitalizeFirstLetter(company.status.replace(
    'STATUS_',
    '',
  ));

  const clevertapParams = {
    Symbol: company.symbol_2 || company.symbol,
    Name: company.name,
    Followers: company.followers,
    'Current Price': parseFloat(company.price),
    'Price Change': parseFloat(company.change),
    'Percentage Change': company.percentage,
    Exchange: company.exchange,
    'Asset Type': company.type_company,
    'Sectoral Index': sectoralIndex?.company_symbol ?? '',
    Sector: company.sector,
    'Sub-Sector': company.sub_sector,
    'Is Watchlist Item': !!company.followed,
    'Is Corporate Action': !!company.corp_action.active,
    'Is Special Notation': !!company.notation.length,
    'Company Status': companyStatus,
  };

  clevertapEvent('Company Page Viewed', clevertapParams);
};
